// Copyright (c) 2016 Deere & Company

import OpenPipsFacet from '../open-pips/state/facets';
import PipSearch from './components';
import actionCreators from './action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.pips.pipSearch,
    exportToExcel: state.exportToExcel,
    laborAdditivePipProductsCount: state.pips.laborAdditive.pipProducts.length,
    openPipProductsCount: state.pips.openPips.pipProducts.length,
    openPipProductsFacets: new OpenPipsFacet({
        ...state.pips.openPips.facets,
        dealerAccountsFacet: {
            ...state.pips.openPips.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    searchByDropDown: state.pips.searchDropDown,
    searchQueryString: state.pips.searchQueryString,
    security: state.user.security,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {location, routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        location,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PipSearch);



// WEBPACK FOOTER //
// ./src/pip/pip-search/state-connector.js